import { render, staticRenderFns } from "./JobBoard.vue?vue&type=template&id=06ff85e5&"
import script from "./JobBoard.vue?vue&type=script&lang=js&"
export * from "./JobBoard.vue?vue&type=script&lang=js&"
import style0 from "./JobBoard.vue?vue&type=style&index=0&id=06ff85e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports